"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
var utilities_1 = require("@fluentui/utilities");
var Toggle_base_1 = require("./Toggle.base");
var Toggle_styles_1 = require("./Toggle.styles");
exports.Toggle = utilities_1.styled(Toggle_base_1.ToggleBase, Toggle_styles_1.getStyles, undefined, {
    scope: 'Toggle',
});
//# sourceMappingURL=Toggle.js.map